import { html } from 'fxjs/es';
import $dataStr from 'fxdom/es/dataStr.js';
import { NessCoreTmplS } from '../../../../Ness/Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessUtilF } from '../../../../Ness/Util/F/Function/module/NessUtilF.js';
import { NessLabsFrameS } from '@modules/NessLabs/Frame/S/index.ts';

const myCharacterItem = (item, no) => {
  const disabled_item = Object.values(item.checker.impossible).some((check) => Boolean(check));
  const need_show_ghost_image = item.checker.impossible.is_collabo_character_or_special_world;

  return html`
    <div
      class="character-item ${disabled_item ? 'disabled' : ''}"
      data-no="${no}"
      data-fx-json="${$dataStr(item)}"
    >
      <div class="selected-order">1</div>
      <div class="character-img-box ${disabled_item ? 'disabled' : ''}">
        <canvas
          class="character-img"
          data-src="${need_show_ghost_image
            ? NessLabsFrameS.NessFrameProduct.canvas_option.images.character.hollow_character_image_url
            : item.maple_image_url}"
        ></canvas>
      </div>
      ${disabled_item ? html`<div class="error-image">${NessCoreTmplS.getErrorIcon()}</div>` : html``}
      <div class="character-name">${item.gc_name}</div>
    </div>
  `;
};

export const myCharacters = (data) => {
  return html`<div class="characters-selector">
    <div class="characters-selector__contents">
      <div class="desc_container">
        <p class="desc">
          ${NessUtilF.isMobile() ? ET('labs::my_characters::desc_mo') : ET('labs::my_characters::desc')}
          ${NessUtilF.isMobile()
            ? html``
            : html`<button class="characters-selector__help">${NessCoreTmplS.getHelpIcon()}</button>`}
        </p>
        <button class="characters-selector__refresh">
          ${NessUtilF.isMobile() ? '초기화' : '선택 초기화'} ${NessCoreTmplS.getRefreshIcon()}
        </button>
      </div>
      <div class="list">${data?.map((item, idx) => myCharacterItem(item, idx)).join('')}</div>
    </div>
    <div class="characters-selector__footer">
      <button class="cancel-button">Cancel</button>
      <button class="generate-button">Generate</button>
    </div>
  </div>`;
};
